import type { FC } from 'react';

import { redirectTo } from '@xing-com/crate-core-router';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useHost } from '@xing-com/crate-xinglet';
import { useFeatureSwitch } from '@xing-com/hub';

import { ManagedCompanies } from '../managed-companies/managed-companies';

export const ManagedCompaniesRoute: FC = () => {
  const { isLoggedIn } = useLoginState();
  const host = useHost();
  const showNewLoggedInOverview = useFeatureSwitch(
    'enable_new_logged_in_companies_overview'
  );

  if (!isLoggedIn) {
    return host.redirectToLogin('/companies/my_companies_edit');
  }

  if (showNewLoggedInOverview) {
    return redirectTo('/companies');
  }

  return <ManagedCompanies />;
};
